import React from 'react'
import { Box } from '@machobear/design-system'

import * as styles from './style.css.ts'

export interface DotsProps {
  count: number
  activeIndex: number
  vertical?: boolean
  onDotClick?: (index: number) => void
}

export const Dots: React.FC<DotsProps> = ({
  count,
  activeIndex,
  vertical = false,
  onDotClick
}) => (
  <div
    className={styles.dotsWrapper({ vertical })}
    role="tablist"
    aria-label="Carousel navigation"
  >
    {Array.from({ length: count })
      .slice(0, 4)
      .map((_, idx) => (
        <Box
          key={idx}
          component="button"
          className={idx === activeIndex % 4 ? styles.dotActive : styles.dot}
          style={{ background: 'white' }}
          onClick={() => onDotClick?.(idx)}
          aria-label={`Go to slide ${idx + 1}`}
          aria-pressed={idx === activeIndex}
          role="button"
          type="button"
        />
      ))}
  </div>
)
